import { module as BaseModule } from 'modujs'
import { html, body } from '../utils/environment'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        close: 'closeBanner',
      },
    }
  }

  init() {
    setTimeout(() => {
      if (body.classList.contains('front-page') && sessionStorage.getItem('ufxstudios.job-banner') !== 'false') {
        html.classList.add('has-job-banner-opened')
      } else {
        html.classList.remove('has-job-banner-opened')
      }
    }, 100)
  }

  closeBanner() {
    html.classList.remove('has-job-banner-opened')
    sessionStorage.setItem('ufxstudios.job-banner', 'false')
  }
}
